module.exports = __webpack_public_path__ + "static/media/Himpunan Business Law BINUS.51c84c39.png";